import { createFileRoute } from '@tanstack/react-router';

import { AttendancePage } from '@/features/teacher/AttendancePage';

export const Route = createFileRoute('/_authed/teacher/attendance')({
  validateSearch: (search): { lesson?: string; student?: string } => ({
    lesson: typeof search.lesson === 'string' ? search.lesson : undefined,
    student: typeof search.student === 'string' ? search.student : undefined,
  }),
  component: AttendancePage,
});
